import type { Issue, Card, MaintenanceChecklist, DecisionNode } from "./types";

import hardwareIssues from "../content/issues-hardware.json";
import printQualityIssues from "../content/issues-print-quality.json";
import processIssues from "../content/issues-process.json";
import rawMaintenance from "../content/maintenance.json";
import rawDecisionTree from "../content/decisionTree.json";
import { cardsData as typedCardsData } from "./content/cards";

const mergedIssues = [
  ...hardwareIssues,
  ...printQualityIssues,
  ...processIssues,
];

export const issuesData = {
  issues: mergedIssues as unknown as Issue[],
};

export const cardsData = typedCardsData as { cards: Card[] };
export const maintenanceData = rawMaintenance as unknown as { checklists: MaintenanceChecklist[] };

export const decisionTreeData = rawDecisionTree as unknown as {
  tree: Record<string, DecisionNode>;
};